module.exports = __webpack_public_path__ + "img/1.f6c52d4e.png";